export default {
  path: "/superadmin",
  component: () => import("@/views/LayoutView.vue"),
  children: [
    {
      path: "",
      redirect: "accounts",
    },

    {
      path: ":dir(accounts)/view/:id",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: route => ({
        getDataUrl: `/accounts/${route.params.id}`,
      }),
    },

    {
      path: ":dir(tickets)/view/:id",
      component: () => import("@/views/superadmin/ticket/TicketView.vue"),
    },

    {
      path: ":dir(tickets)/statistic",
      component: () => import("@/views/superadmin/ticket/TicketStatistic.vue"),
    },

    {
      path: ":dir(monitoring)",
      component: () => import("@/views/superadmin/monitoring/SuperadminMonitoring.vue"),
    },

    {
      path: ":dir(organizations)/view/:id",
      component: () => import("@/views/superadmin/branches/BranchList.vue"),
      props: route => ({
        getDataUrl: `/organizations/${route.params.id}`,
      }),
    },

    {
      path: ":dir(groups)/view/:id",
      component: () =>
        import("@/views/superadmin/journal/JournalView.vue"),
    },

    {
      path: ":dir/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
    },

    {
      path: ":dir/view/:id",
      component: () => import("@/components/default/view/DefaultView.vue"),
    }

  ],
};
